import baseApi from "@/api/baseApi";

export const getNotas = async ({ commit }) => {
  const { data } = await baseApi.get("/api/v1/getNotas");
  commit("setNotas", data.data);
  return data;
};

export const createNotas = async (contex, obj) => {
  try {
    const { data } = await baseApi.post("/api/v1/createNotas", obj);
    return data;
  } catch (error) {
    console.log("Error", error);
    localStorage.removeItem("sp_tk");
    window.location.reload();
  }
};

export const editNotas = async (contex, obj) => {
  try {
    const { data } = await baseApi.post("/api/v1/editNotas", obj);
    return data;
  } catch (error) {
    console.log("Error", error);
    localStorage.removeItem("sp_tk");
    window.location.reload();
  }
};
export const deleteNotas = async (contex, obj) => {
  try {
    const { data } = await baseApi.post("/api/v1/deleteNotas", obj);
    return data;
  } catch (error) {
    console.log("Error", error);
    localStorage.removeItem("sp_tk");
    window.location.reload();
  }
};
